import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { VIEW_ALL_TYPES } from '@app/mpp/shared/enum/ingredient-enum';
import { IngredientSearchResult } from '@app/mpp/shared/model/ingredient-search-result';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-ingredient-search-recipe',
  templateUrl: './ingredient-search-recipe.component.html',
  styleUrls: ['./ingredient-search-recipe.component.scss'],
})
export class IngredientSearchRecipeComponent {
  @Input() ingredientSearchResult$: Observable<IngredientSearchResult[]>;
  @Input() viewAllState: VIEW_ALL_TYPES;
  @Output() selectIngredientToAddEvent =
    new EventEmitter<IngredientSearchResult>();
  constructor() {}

  selectIngredientToAdd(ingredient: IngredientSearchResult) {
    this.selectIngredientToAddEvent.emit(ingredient);
  }
}
